import $ from 'jquery'
import Swiper from 'swiper/bundle'

const initializeBlock = function ($block) {
  const wrapper = $block.find('.training-centers-block__content-wrapper')

  if (!wrapper.length) {
    return
  }

  new Swiper(wrapper[0], {
    slidesPerView: 1.1,
    spaceBetween: 30,
    navigation: {
      prevEl: $block.find('.prev span')[0],
      nextEl: $block.find('.next span')[0],
    },
    breakpoints: {
      576: {
        slidesPerView: 1.1,
      },
      768: {
        slidesPerView: 1.5,
      },
      992: {
        slidesPerView: 2,
      },
    },
  })
}

$('.training-centers-block').each(function () {
  initializeBlock($(this))
})

if (window.acf) {
  window.acf.addAction(
    'render_block_preview/type=vn-training-centers',
    initializeBlock
  )
}
